import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Icon } from "@/lib/ui";

export default function Profile() {
  const { user, logout, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/profile", { name, phone });
      setUser(data.data);
      toast.success("Profile updated");
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="px-5 pt-8">
      <h1 className="font-display font-black text-3xl tracking-tight">Profile</h1>

      <div className="flex items-center gap-4 mt-6">
        <div className="w-16 h-16 rounded-full bg-primary text-primary-foreground grid place-items-center font-display font-black text-2xl">
          {user?.name?.[0]?.toUpperCase()}
        </div>
        <div>
          <p className="font-semibold text-lg">{user?.name}</p>
          <p className="text-sm text-muted-foreground">{user?.email}</p>
        </div>
      </div>

      <div className="mt-8 space-y-4">
        <label className="block">
          <span className="text-sm font-semibold">Full name</span>
          <input data-testid="profile-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5 w-full h-14 px-4 rounded-xl border border-input focus:outline-none focus:ring-2 focus:ring-ring" />
        </label>
        <label className="block">
          <span className="text-sm font-semibold">Mobile number</span>
          <input data-testid="profile-phone" value={phone} onChange={(e) => setPhone(e.target.value)} className="mt-1.5 w-full h-14 px-4 rounded-xl border border-input focus:outline-none focus:ring-2 focus:ring-ring" />
          <span className="text-xs text-muted-foreground mt-1 block">Updating your number is used for future contact flows only where you enable it per-tag.</span>
        </label>
        <button data-testid="profile-save" onClick={save} disabled={busy} className="tap w-full h-14 rounded-full bg-primary text-primary-foreground font-bold disabled:opacity-60">Save changes</button>
      </div>

      <button data-testid="logout-btn" onClick={logout} className="tap w-full h-14 mt-8 rounded-full border border-border font-bold text-status-lost flex items-center justify-center gap-2">
        <Icon name="LogOut" className="w-4 h-4" /> Log out
      </button>
    </div>
  );
}
